import styled, { keyframes } from 'styled-components';

// Layout constants shared between Container, Footer, ButtonCont, and App SidebarCont
export const CONTENT_MAX_WIDTH = '600px';
export const SIDEBAR_DESKTOP_OFFSET = '425px';
export const SIDEBAR_TABLET_OFFSET = '290px';
export const TABLET_HORIZONTAL_PADDING = '40px';

export const FormSection = styled.div`
  @media (min-width: 1025px) {
    min-height: ${(props: FormSectionProps) => (props.smaller ? '110px' : '120px')};
  }
  @media (max-width: 1024px) {
    margin-bottom: 32px;
  }
`;

interface FormSectionProps {
  smaller?: boolean;
}

export const Container = styled.div`
  max-width: ${CONTENT_MAX_WIDTH};
  display: flex;
  flex-direction: column;
  margin: 0 auto 0 auto;
  box-sizing: border-box;
  @media (min-width: 1025px) {
    margin: 0;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    max-width: calc(100vw - ${SIDEBAR_TABLET_OFFSET});
    width: 100%;
    padding: 0 ${TABLET_HORIZONTAL_PADDING};
  }
  @media (max-width: 767px) {
    padding: 0px 24px;
  }
`;

const LoadingContainer = styled.div`
  max-width: 100%;
`;

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const LoadingDualRing = styled.div`
  display: inline-block;
  max-width: 64px;
  height: 34px;

  :after {
    content: ' ';
    display: block;
    width: 24px;
    height: 24px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid ${({ theme }) => theme.pageComponents.elements.containers.border};
    border-color: ${({ theme }) => theme.pageComponents.elements.containers.borderColor};
    animation: ${spin} 1.2s linear infinite;
  }
`;

export const LoadingSpinner = () => (
  <LoadingContainer>
    <LoadingDualRing />
  </LoadingContainer>
);

export const ToolTipHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const LocationQuestionContainer = styled.div`
  width: auto;
  @media (min-width: 768px) and (max-width: 1024px) {
    &:first-child {
      margin-right: 20px;
    }
  }
`;

export const InputCont = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (min-width: 1025px) {
    flex-direction: row;
    column-gap: 8px;
  }

  @media (max-width: 767px) {
    margin-top: 12px;
  }
`;

export const InputBox = styled.div`
  flex: 1;
  max-width: 292px;
  @media (max-width: 767px) {
    max-width: 100%;
  }
`;
